import { render, staticRenderFns } from "./Channels.vue?vue&type=template&id=64542f18&scoped=true&"
import script from "./Channels.vue?vue&type=script&lang=ts&"
export * from "./Channels.vue?vue&type=script&lang=ts&"
import style0 from "./Channels.vue?vue&type=style&index=0&id=64542f18&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64542f18",
  null
  
)

component.options.__file = "Channels.vue"
export default component.exports